<app-sidenav (onToggleSideNav)="onToggleSideNav($event)"></app-sidenav>
<app-body
  [collapsed]="isSideNavCollapsed"
  [screenWidth]="screenWidth"
></app-body>
<app-footer></app-footer>
